// eslint-disable-next-line
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client/react';
import { BlackButton } from '@cb/apricot-react';
import { UPDATE_STUDENT } from '../../../../../apollo/mutations';
import { seatsAvailable } from '../../../../../utils/common';
import { ModalDispatchContext } from '../../../../ui/modal/ModalContext';
import OneButtonModal from '../../../../ui/modal/standard/OneButtonModal';
import TwoButtonModal from '../../../../ui/modal/standard/TwoButtonModal';
import { useNavigate } from 'react-router-dom';

function MarkAbsentButton({ student = {} }) {
  // Global Modal context.
  const dispatchModal = useContext(ModalDispatchContext);
  // Apollo.
  const [updateStudent] = useMutation(UPDATE_STUDENT);

  const navigate = useNavigate();

  function changeRoom() {
    dispatchModal(null);

    navigate('/students/bulkOperations/assign', {
      state: {
        students: [student],
      },
    });
  }

  function handleMarkAbsentContinueFromModal() {
    const input = {
      absent: !student.absent,
      checkedInCenter: false,
      checkedInRoom: false,
      deniedEntry: false,
      id: student.id,
    };

    updateStudent({ variables: { input } })
      .then(() => {
        dispatchModal(
          <OneButtonModal
            body={student.absent ? 'You’ll still need to check the student in.' : ''}
            modalId='studentMarkAbsentCompleted'
            title={`You’ve marked this student as ${student.absent ? 'not' : ''} absent.`}
            variant='success'
          />
        );
      })
      .catch((e) => {
        // Some server error.
        console.error('student mark absent failed', e);
      });
  }

  function markAbsent() {
    const availableSeats = seatsAvailable(student.room);

    // Check available seats to ensure they are capable of being added back in.
    if (availableSeats < 1 && student.deniedEntry && student.room) {
      return dispatchModal(
        <TwoButtonModal
          body='Move the student to a new room. There are no seats available in their original room.'
          modalId='studentChangeTestingRoom'
          primaryButtonHandler={changeRoom}
          primaryButtonLabel='Change Testing Room'
          title='Mark Student Not Absent'
        />
      );
    } else {
      return dispatchModal(
        <TwoButtonModal
          body={`You’re about to mark this student ${student.absent ? 'not' : ''} absent.`}
          modalId='studentMarkAbsentConfirmation'
          primaryButtonHandler={handleMarkAbsentContinueFromModal}
          variant='error'
        />
      );
    }
  }

  return (
    <BlackButton onClick={markAbsent} id='button-absent' data-automation='button-absent' small className='mb-3 w-100'>
      {student.absent ? 'Undo Mark as Absent' : 'Mark as Absent'}
    </BlackButton>
  );
}

MarkAbsentButton.propTypes = {
  student: PropTypes.object,
};

export default MarkAbsentButton;
